import { Route, createBrowserRouter, createRoutesFromElements, Navigate } from 'react-router';

import { Routes, type IRouteModel } from '@/_navigation';
import {
  BridgePlanPage,
  CheckoutPage,
  ClimbSuccessPage,
  CollegeInfoPage,
  ProgramRequirementPage,
  RequirementPage,
  ConsentPage,
  InvestmentPage,
  MainPage,
  PaymentOptionsPage,
  SuccessPage,
  UpdatePlanPage,
  TestPage,
  Terms,
} from '@/_pages';
import { BridgePlanProvider, CacheProvider, AuditTrailProvider } from '@/_providers';

import Administrator from './_containers/administrator';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Administrator />}>
      <Route element={<CacheProvider />}>
        <Route element={<BridgePlanProvider />}>
          <Route element={<AuditTrailProvider />}>
            <Route path={genLink(Routes.COLLEGE_INFO)} element={<CollegeInfoPage />} />
            <Route path={genLink(Routes.COLLEGE_PROG_REQ)} element={<ProgramRequirementPage />} />
            <Route path={genLink(Routes.COLLEGE_REQ)} element={<RequirementPage />} />
            <Route path={genLink(Routes.TERMS)} element={<Terms />} />
            <Route path={genLink(Routes.INVESTMENT)} element={<InvestmentPage />} />
            <Route path={genLink(Routes.PAYMENT_OPTIONS)} element={<PaymentOptionsPage />} />
            <Route path={genLink(Routes.CHECKOUT)} element={<CheckoutPage />} />
            <Route path={genLink(Routes.UPDATE)} element={<UpdatePlanPage />} />
            <Route path={genLink(Routes.SUCCESS)} element={<SuccessPage />} />
            <Route path={genLink(Routes.CLIMB_SUCCESS)} element={<ClimbSuccessPage />} />
            <Route path={genLink(Routes.CONSENT)} element={<ConsentPage />} />
            <Route path={genLink(Routes.BRIDGE_PLAN)} element={<BridgePlanPage />} />

            {/* <Route
								path={genLink(Routes.INFO)}
								element={<Suspense fallback={<SubPagePreLoader />}><WithAuthRedirect component={CustomerInfo} route={Routes.INFO} /></Suspense>}
							/>
							<Route
								path={genLink(Routes.PAYMENT_METHODS)}
								element={<Suspense fallback={<SubPagePreLoader />}><WithAuthRedirect component={PaymentMethods} route={Routes.PAYMENT_METHODS} /></Suspense>}
							/>
							<Route
								path={genLink(Routes.COMPLETE_ORDER)}
								element={<Suspense fallback={<SubPagePreLoader />}><WithAuthRedirect component={CompleteOrder} route={Routes.COMPLETE_ORDER} /></Suspense>}
							/> */}
          </Route>
        </Route>
      </Route>

      <Route path={Routes.TEST.link as string} element={<TestPage />} />
      <Route path={Routes.MAIN.link as string} element={<MainPage />} />
      <Route path="*" element={<Navigate to={Routes.MAIN.link} />} />
    </Route>
  )
);

export default router;

function genLink({ link, params }: IRouteModel) {
  return `${link || ''}${params}`;
}
